// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__3IX15","body":"Tooltip_body__1waID"};